export default __webpack_public_path__ + "static/media/slide-2.0eea295c.png";